// extracted by mini-css-extract-plugin
export default {"list":"ChatMainArea_list__mfBRz","chatbox":"ChatMainArea_chatbox__XiNBi"};